// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".iaWYjJPOx{margin-bottom:20px !important}.zH8rqlPfx{padding:10px 9px;padding-bottom:20px}._4dgCsdwvx{padding:0 8px;color:var(--secondary-text);font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Helvetica,Ubuntu,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";text-decoration:none;font-size:12px}._4uo4gS1jx{display:flex;flex-shrink:0;justify-content:flex-end}._4HEAawymx{font-size:0}._4HEAawymx:hover svg path{fill-opacity:0.59}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"mobile-filler": "iaWYjJPOx",
	"mobileFiller": "iaWYjJPOx",
	"legal-and-policy": "zH8rqlPfx",
	"legalAndPolicy": "zH8rqlPfx",
	"legal": "_4dgCsdwvx",
	"expander": "_4uo4gS1jx",
	"expander-button": "_4HEAawymx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-s"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-outline"] + "",
	"expanderButton": "_4HEAawymx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-s"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-outline"] + ""
};
module.exports = exports;
